import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import Button from "components/Button/Button";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import Footer from 'components/Footer/Footer';
import './style.css';
// import home from 'Assets/home.svg';

const UnknownError = () => (
  <div>
  <Helmet>
    <title>PechaKucha Oops</title>
    <meta name="robots" content="noindex" />
  </Helmet>
    <div className="noPage">
      {/* <img src={PageNotFound} style={{width: "100%", height: 686, margin: 'auto', position: 'relative' }} /> */}
      <div className="notFoundContainer">
        <div className="container">
            <Row>
              <Col lg={3} md={2} sm={0}></Col>
              <Col lg={8} md={10} sm={12}>
              <div className="oopsData">
                <div style={{ paddingTop: "10%" }} className="pageNotFound">
                  <h1>Whoops! Something went wrong</h1>
                  <p>There was a technical error. If you contact support, please copy/paste the error trace below into your support ticket.
                  </p>
                  { window.localStorage.getItem('pk_error_message') &&
                    <pre>
                      {window.localStorage.getItem('pk_error_message')}
                    </pre>
                  }
                  <Link to="/">
                  <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 goback-btn">
                    Go Back Home
                  </Button>
                  </Link>
                </div>
                </div>
              </Col>
            </Row>
        </div>
      </div>
    </div>
  </div>
);

export default UnknownError;